import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const PatisserieTable = ({ data, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Internal Name</TableCell>
            <TableCell>Display Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Flavor</TableCell>
            <TableCell>Regular Price</TableCell>
            <TableCell>Wedding Price</TableCell>
            <TableCell>Image</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item._id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.displayName}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>{item.category}</TableCell>
              <TableCell>{item.flavor}</TableCell>
              <TableCell>${item.orderConfig.regular.price}</TableCell>
              <TableCell>
                {item.orderConfig.wedding?.price
                  ? `$${item.orderConfig.wedding.price}`
                  : "N/A"}
              </TableCell>
              <TableCell>
                <img
                  src={item.images?.regularOrderImage}
                  alt={item.name}
                  style={{ width: "100px", borderRadius: "8px" }}
                />
              </TableCell>
              <TableCell align="right">
                <IconButton color="primary" onClick={() => onEdit(item)}>
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  onClick={() => onDelete(item._id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PatisserieTable;
